module.exports = __webpack_public_path__ + "img/FlyingCarpet.143c429e.gif";